export const TRACKING_SCREENS = {
  REQUEST_FORM: 'request-form',
  VERIFY_REQUEST: 'verify-request',
  MISSING_SLUG: 'missing-slug'
};
export const INTERACTIONS = {
  SUBMIT_REQUEST: 'submit-request',
  LOCALE_CHANGE: 'locale-change',
  VERIFY_REQUEST: 'verify-request'
};